import React, { forwardRef } from "react";
import Input, { InputProps } from "components/foundation/Input/Input";
import styled, { css } from "styled-components";

interface UserProfileInputProps extends InputProps {
  label: string;
  type?: string;
}

export const UserProfileInput = forwardRef<
  HTMLInputElement,
  UserProfileInputProps
>(({ label, children, type, errorMessage, ...args }, ref) => {
  return (
    <UserProfileInputLayout>
      <p>{label}</p>
      <Input type={type} ref={ref} errorMessage={errorMessage} {...args} />
      {children}
    </UserProfileInputLayout>
  );
});

const UserProfileInputLayout = styled.div`
  p {
    ${({ theme }) => css`
      ${theme.typography.body1.medium};
      margin-bottom: 1rem;

      ${theme.media.small} {
        ${({ theme }) => theme.typography.body3.medium};
        margin-bottom: 0.6rem;
      }
    `};
  }
  > div {
    display: flex;
    gap: 1rem;
  }
`;

UserProfileInput.displayName = "UserProfileInput"; // displayName 설정
